import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TanstackTableLocale } from '@thingslog/ui-components';

/**
 * Builds the `TanstackTable` UI locale from the app's i18n. Every key carries
 * its English default, so a translation that has not been added yet renders as
 * English rather than as the raw key.
 */
export function useTableLocale(): TanstackTableLocale {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      searchLabel: t('table_search_label', 'Search'),
      searchPlaceholder: t('table_search_placeholder', 'Search…'),
      columnsButton: t('table_columns', 'Columns'),
      toggleAll: t('table_toggle_all', 'Toggle all'),
      filter: t('table_filter', 'Filter'),
      clearFilter: t('table_clear_filter', 'Clear filter'),
      pinLeft: t('table_pin_left', 'Pin left'),
      pinRight: t('table_pin_right', 'Pin right'),
      unpin: t('table_unpin', 'Unpin'),
      groupByColumn: t('table_group_by_column', 'Group by this column'),
      ungroup: t('table_ungroup', 'Ungroup'),
      filterAll: t('table_filter_all', 'All'),
      noValues: t('table_no_values', 'No values'),
      min: t('table_min', 'Min'),
      max: t('table_max', 'Max'),
      equals: t('table_equals', 'Equals'),
      from: t('table_from', 'From'),
      to: t('table_to', 'To'),
      yes: t('table_yes', 'Yes'),
      no: t('table_no', 'No'),
      filterLabel: t('table_filter_label', 'Filter'),
      filterPlaceholder: t('table_filter_placeholder', 'Filter…'),
      densityCompact: t('table_density_compact', 'Compact'),
      densityStandard: t('table_density_standard', 'Standard'),
      densityComfortable: t('table_density_comfortable', 'Comfortable'),
      autoPageSizeLabel: t('table_auto_page_size', 'Auto ({rows})'),
    }),
    [t]
  );
}
